'use client';

type SplitScreenComponentProps = {
  leftContent: React.JSX.Element;
  rightContent: React.JSX.Element;
  useBodyBackground?: boolean;
  leftContentOnTop?: boolean;
  verticalAlignTop?: boolean;
};

export function SplitScreenComponent({
  leftContent,
  rightContent,
  useBodyBackground = false,
  leftContentOnTop = false,
  verticalAlignTop = false,
}: SplitScreenComponentProps) {
  const flexDirection = leftContentOnTop ? 'flex-col md:flex-row' : 'flex-col-reverse md:flex-row';
  const stackJustify = leftContentOnTop ? 'justify-start' : 'justify-end';
  const leftBackground = useBodyBackground
    ? 'bg-jade-background-body'
    : 'bg-jade-background-body min-500:bg-jade-background-surface';
  const rightPadding = leftContentOnTop ? 'pb-jade-300' : 'pb-0 md:pb-jade-300';
  const verticalAlign = verticalAlignTop ? 'justify-start' : 'justify-center';
  return (
    <div className={`min-h-screen h-full flex flex-col items-center ${verticalAlign} bg-jade-background-body`}>
      <div className={`flex flex-grow ${stackJustify} md:justify-between flex-wrap max-w-full md:max-w-[1440px] w-full ${flexDirection}`}>
        <div
          data-testid="left-content"
          className={`flex flex-col items-center flex-none md:flex-1 w-full min-500:w-auto ${leftBackground}`}
        >
          {leftContent}
        </div>
        <div
          data-testid="rigth-content"
          className={`flex-none md:flex-1 md:h-full w-full min-500:w-auto bg-jade-background-body ${rightPadding}`}
        >
          {rightContent}
        </div>
      </div>
    </div>
  );
}
